import {WarningBanner} from '@/components/commons/warning-banner/WarningBanner'
import {ProjectCreationError, ProjectStatus} from '@/features/projects/types'
import {projectStatusToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'

export const ProjectFormWarningBanner = ({error, status}: {error: ProjectCreationError; status?: ProjectStatus}) => {
    const {t} = useTranslation()

    const errorTitleDescriptionMap = {
        already_exists: {
            title: t('projects:error_project_creation'),
            description: t('projects:error_no_project_description', {
                status: status ? t(projectStatusToLabel[status]).toLowerCase() : ''
            })
        },
        deceased: {
            title: t('projects:error_project_creation'),
            description: t('projects:error_deceased_patient')
        },
        tratment_request_error: {
            title: t('projects:error_project_creation'),
            description: t('projects:error_no_treatment_request')
        }
    } as const satisfies Record<ProjectCreationError, {title: string; description: string}>

    return (
        <WarningBanner
            title={errorTitleDescriptionMap[error].title}
            subtitle={errorTitleDescriptionMap[error].description}
        />
    )
}
